var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 0C7.74994 0 3.90051 3.85049 3.90051 8.60047C3.90051 12.2213 8.89896 20.5647 11.274 24.325C11.5402 24.7454 12.0036 24.9999 12.5008 24.9999C12.9981 24.9989 13.4606 24.7446 13.726 24.3242C16.1018 20.563 21.0995 12.2212 21.0995 8.60042C21.0994 3.85049 17.25 0 12.4999 0ZM12.4999 13.851C9.81364 13.851 7.63591 11.6736 7.63591 8.98699C7.63591 6.30066 9.81359 4.12298 12.4999 4.12298C15.1862 4.12298 17.3639 6.30061 17.3639 8.98699C17.3639 11.6736 15.1863 13.851 12.4999 13.851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/region.8c067ea890b2c42e934d3f9084780829.svg";
export { ForwardRef as ReactComponent };